<template>
  <div id="prop-breadcrumbs" aria-label="Breadcrumb">
    <ul class="flex">
      <li class="list" v-for="(breadcrumb, i) in breadcrumbItems" :key="i">
        <a class="breadcrumb" :href="breadcrumb.url">{{ breadcrumb.name }}</a>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  props: {
    breadcrumbItems: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
.flex {
  padding: 0;
  display: block;
  margin: 0 1.25rem;
  overflow-x: scroll;
  flex-direction: row;
  scrollbar-width: none;
  border: 1px solid #D9D9D9;
  @media #{$desktop} {
    padding: 0;
    border: none;
    display: flex;
    margin: 1.25rem 0;
  }
}
.list {
  margin: 0;
  display: flex;
  font-size: 14px;
  list-style: none;
  line-height: 16px;
  position: relative;
  flex-direction: row;
  border-bottom: 1px solid #D9D9D9;
  &::before {
    top: 50%;
    content: "";
    left: 0.75rem;
    display: block;
    width: .875rem;
    height: .875rem;
    position: absolute;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(90deg) translate(-50%);
    background-image: url('../../assets/images/global/arrow-down.svg');
  }
  @media #{$desktop} {
    padding: 0;
    border: none;
    &::before {
      display: none;
    }
    &::after{
      content: ">";
      width: 16px;
      height: 14px;
      display: block;
      text-align: center;
    }
    &:last-child::after {
      display: none;
    }
  }
}
.breadcrumb {
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  max-width: unset;
  position: relative;
  color: var(--primary-color);
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  padding: 1.125rem 1.25rem 1.125rem 2rem;
  @media #{$desktop} {
    padding: 0;
  }
}
</style>
